import { createPluginMeta } from '@reflex/plugin-api/meta';
import { definePlugin } from '@reflex/plugin-api';

const meta = createPluginMeta(import.meta.url);

/**
 * The easter eggs, kept out of the product's own source tree.
 *
 * One egg so far: **smooth jazz mode**. Clicking a "j" in an agent's title
 * offers a track from the Smoke Room set list, and accepting it books a set
 * with a channel-driven light show and a transport for skipping, minimising,
 * and stopping.
 *
 * Web-only — no server, schema, or API surface. Each egg mounts its host
 * through `globalUiElements`, which the app shell renders unconditionally, and
 * the host renders nothing until someone finds it. Triggers are resolved by
 * the host through the plugin component registry, so core web carries the
 * seams and none of the jokes.
 */
export const easterEggsPlugin = definePlugin({
  name: 'easter-eggs',
  version: meta.version,
  description: 'Hidden extras. Clicking a "j" in an agent title books a smooth jazz set.',
  icon: 'plugin-icon-easter-eggs.png',
  iconPath: meta.iconPath,
  tags: ['easter-egg', 'fun'],
  web: {
    globalUiElements: [
      {
        id: 'jazz-mode-host',
        componentPath: '@reflex/plugin-easter-eggs/web/JazzModeHost',
      },
    ],
  },
});
